import { render, staticRenderFns } from "./UserFriends.vue?vue&type=template&id=b26c07a4&scoped=true&"
import script from "./UserFriends.vue?vue&type=script&lang=js&"
export * from "./UserFriends.vue?vue&type=script&lang=js&"
import style0 from "./UserFriends.vue?vue&type=style&index=0&id=b26c07a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26c07a4",
  null
  
)

export default component.exports